module.exports = __webpack_public_path__ + "static/img/Spectrum-Image.a69c9eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Spectrum-Image.jpg
// module id = 8FEc
// module chunks = 0